import type { IconData } from '@stacksjs/iconify-core'

export const pa1x1: IconData = {
  "body": "<defs><clipPath id=\"SVGMa12rbIW\"><path fill-opacity=\".7\" d=\"M0 0h512v512H0z\"/></clipPath></defs><g fill-rule=\"evenodd\" clip-path=\"url(#SVGMa12rbIW)\"><path fill=\"#fff\" d=\"M-26-25h592.5v596H-26z\"/><path fill=\"#db0000\" d=\"M255.3-20.4h312.1v275.2h-312z\"/><path fill=\"#0000ab\" d=\"M-54.5 254.8h309.9V571H-54.5zM179 181.6l-46.5-29.2l-46.2 29.5l17.2-48l-46.2-29.6l57.1-.4l17.7-47.8l18.1 47.7h57.1l-45.9 30z\"/><path fill=\"#d80000\" d=\"m435.2 449l-46.4-29.2l-46.3 29.5l17.2-48l-46.2-29.5l57.2-.4l17.7-47.8l18 47.7h57.2l-46 30z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default pa1x1
